import helpers from './index'

export default (timings) => {
	for (let i = 0; i < timings.length; i++) {
		timings[i].started_at = helpers.addTimeZoneDiff(timings[i].started_at);
	}
	return timings;
}
